import {AfterViewInit, Component, ElementRef, EventEmitter, ViewChild, ViewEncapsulation} from '@angular/core';
import {Router} from "@angular/router";
import {TResetModal} from '../../../services/utils/state-management/types';
import {RESET_MODAL_HARD, RESET_MODAL_SOFT} from '../../../services/utils/state-management/actions';
import {TranslateService} from '@ngx-translate/core';
import {LanguageChangeService} from '../../../services/language-change.service';
import {BsModalRef} from 'ngx-bootstrap/modal';
import {DateTimeAdapter} from '@danielmoncada/angular-datetime-picker';
import {Config} from 'src/app/services/utils/Config';

export interface HomeHistoryOptionsModal {
  homeID: string
  activities: Object
  sources: Object,
  filters: Object
}
@Component({
  selector: 'app-home-history-filter-modal',
  templateUrl: './home-history-filter-modal.component.html',
  styleUrls: ['./home-history-filter-modal.component.css'],
  encapsulation: ViewEncapsulation.None
})
export class HomeHistoryFilterModalComponent implements HomeHistoryOptionsModal, AfterViewInit {

  homeID: string;
  currentTab = 0;
  homeLocks = [];
  selectedLocks = [];
  selectedActivities = [];
  selectedGdoActivities = [];
  filters;
  activities = [];
  sources = [];
  gdoActivities = [];
  selectedSources = [];
  modalCss = 'modal-view';
  selectedMoments = [];
  filterTypes = {
    LOCK: 'lock',
    DATE_RANGE: 'daterange',
    USER_TYPE: 'usertype',
    ACTIVITY: 'activity'
  }
  errorMsg = "Enter or choose any value before applying the filter"
  errorDisplay = "";
  fromDate;
  toDate;
  minDate;
  maxDate;
  private resetType: TResetModal = RESET_MODAL_SOFT;
  lastTab: number;
  tabs = {
    LOCKS: 1,
    RANGE_PICKER: 2,
    USER_TYPE: 3,
    ACTIVITIES: 4,
    GDO_ACTIVITIES: 5
  }
  result: {};
  event: EventEmitter<any> = new EventEmitter();
  eventClose: EventEmitter<any> = new EventEmitter();
  //Selected Language
  langCode: string;
  defaultLangCode: string;
  holdLastActivity = [];
  holdLastGdoActivity = [];
  holdSelectedSources= [];
  holdSelectedMoments = [];
  holdSelectedLocks = [];

  @ViewChild('filterModal') filterModal: ElementRef;

  constructor(public router: Router,
    public translate: TranslateService,
    private langService: LanguageChangeService,
    public bsModalRef: BsModalRef,
    private dateAdapter: DateTimeAdapter<any>) {
    // super();
    let date = new Date();
    this.toDate = date; //.toISOString().split("T")[0];
    date = new Date(Date.now() - (2 * 30 * 24 * 60 * 60 * 1000));
    this.fromDate = date; ///.toISOString().split("T")[0];
    this.minDate = this.fromDate;
    this.maxDate = this.toDate + (12 * 60 * 60 * 1000); // add 12 hours
  }

  ngOnInit() {
    if (this.langService.getCurrentLanguage() === Config.LANGUAGES.FRENCH) {
      this.dateAdapter.setLocale(Config.LANGUAGES.FRENCH);
    } else {
      this.dateAdapter.setLocale(Config.LANGUAGES.ENGLISH);
    }
    this.langCode = this.langService.getCurrentLanguage();
    this.defaultLangCode = this.langService.getDefaultLanguage();
    document.getElementsByTagName('body')[0].style.overflow = 'hidden'
    this.homeLocks = null;
    this.selectedSources = this.filters.selectedSource ? this.filters.selectedSource : [];
    this.selectedActivities = this.filters.selectedActivities ? this.filters.selectedActivities : [];
    this.selectedGdoActivities = this.filters.selectedGdoActivities ? this.filters.selectedGdoActivities : [];
    this.selectedMoments = [this.filters.fromDate, this.filters.toDate];
    this.selectedLocks = this.filters.selectedLocks ? this.filters.selectedLocks : [];

    if (this.selectedSources.length || this.selectedActivities.length || this.selectedGdoActivities.length || this.selectedLocks.length || (this.filters.fromDate && this.filters.toDate)) {
      this.resetType = RESET_MODAL_HARD;
    }
  }


  /**
   * @description prevent to focus background input and focus to modal input
   * @returns void
   */
  focusInput(): void {
    this.filterModal.nativeElement.focus();
  }

  /**
   * @description this is angular hook responisble when page fully load
   * @returns void
   */
  ngAfterViewInit(): void {
    setTimeout(() => {
      this.focusInput();
    }, 0);
  }

  changeTab(tabId, filterApplied, IsbackButton = false, activeTabId = 1) {
    this.errorDisplay = "";
    this.preSelectedValue(IsbackButton, tabId); // initial state hold of lock, date picker, usertype, activities
    if (tabId === this.tabs.LOCKS) {
      this.lastTab = this.tabs.LOCKS;
      this.modalCss = 'modal-view-input'
    } else if (tabId === this.tabs.RANGE_PICKER) {
        this.lastTab = this.tabs.RANGE_PICKER;
      this.modalCss = 'modal-view-date-picker';
    } else if (tabId === this.tabs.USER_TYPE) {
        this.lastTab = this.tabs.USER_TYPE;
      this.modalCss = 'modal-view-input'
    } else if (tabId === this.tabs.ACTIVITIES) {
      this.lastTab = this.tabs.ACTIVITIES;
      this.modalCss = 'modal-view-list'
    } else if (tabId === this.tabs.GDO_ACTIVITIES) {
      this.lastTab = this.tabs.GDO_ACTIVITIES;
      this.modalCss = 'modal-view-list'
    }
    else {
      if (!filterApplied) {
        this.emptyFilters();
      }
      this.modalCss = 'modal-view';
      // hold value for back button click resign to values
      this.preSelectedValue(IsbackButton, activeTabId);
    }
    this.currentTab = tabId
  }


  private preSelectedValue(IsbackButton: boolean, activeTabId: number) {
    switch (activeTabId) {
      case 1:
        if (IsbackButton)
          this.selectedLocks = [...this.holdSelectedLocks];
        else
          this.holdSelectedLocks = [...this.selectedLocks];
        break;
      case 2:
        if (IsbackButton)
          this.selectedMoments = [...this.holdSelectedMoments];
        else
          this.holdSelectedMoments = [...this.selectedMoments];
        break;
      case 3:
        if (IsbackButton)
          this.selectedSources = [...this.holdSelectedSources];
        else
          this.holdSelectedSources = [...this.selectedSources];
        break;
      case 4:
        if (IsbackButton)
          this.selectedActivities = [...this.holdLastActivity];
        else
          this.holdLastActivity = [...this.selectedActivities];
        break;
      case 5:
        if (IsbackButton)
          this.selectedGdoActivities = [...this.holdLastGdoActivity];
        else
          this.holdLastGdoActivity = [...this.selectedGdoActivities];
        break;
      default:
        break;
    }

  }

  emptyFilters() {
    if (this.lastTab === this.tabs.LOCKS) {
      this.selectedLocks = [];
    } else if (this.lastTab === this.tabs.RANGE_PICKER) {
      this.selectedMoments = [];
    } else if (this.lastTab === this.tabs.USER_TYPE) {
      this.selectedSources = [];
    } else if (this.lastTab === this.tabs.ACTIVITIES) {
      this.selectedActivities = [];
    } else if (this.lastTab === this.tabs.GDO_ACTIVITIES) {
      this.selectedGdoActivities = [];
    }
  }

  addLockFilter(event) {
    this.errorDisplay = "";
    if (event.target.value) {
      this.selectedLocks = [event.target.value];
    } else {
      this.selectedLocks = [];
    }
  }

  addActivityFilter(activity) {
    this.errorDisplay = "";
    let index = this.selectedActivities.findIndex(name => activity[this.defaultLangCode] === name[this.defaultLangCode]);
    if (index > -1) {
      this.selectedActivities.splice(index, 1);
    } else {
      this.selectedActivities.push(activity);
    }
  }

  addGdoActivityFilter(activity) {
    this.errorDisplay = "";
    let index = this.selectedGdoActivities.findIndex(name => activity[this.defaultLangCode] === name[this.defaultLangCode]);
    if (index > -1) {
      this.selectedGdoActivities.splice(index, 1);
    } else {
      this.selectedGdoActivities.push(activity);
    }
  }

  addSourceFilter(event) {
    this.errorDisplay = "";
    if (event.target.value) {
      this.selectedSources = [event.target.value];
    } else {
      this.selectedSources = [];
    }
  }

  closeDialog() {
    let setFilter = false;
    if (this.selectedLocks.length || this.selectedSources.length || this.selectedActivities.length || this.selectedGdoActivities.length || (this.selectedMoments[0] && this.selectedMoments[1])) {
      setFilter = true;
    }
    const [fromDate, toDate] = this.selectedMoments;
    this.result = { setFilter, selectedLocks: this.selectedLocks, selectedSource: this.selectedSources, selectedActivities: this.selectedActivities, selectedGdoActivities: this.selectedGdoActivities, fromDate, toDate }
    this.event.emit(this.result);
    this.bsModalRef.hide();
    document.getElementsByTagName('body')[0].style.overflowY = 'scroll'
  }

  resetFilterAndCloseDialog() {
    this.result = { setFilter: false };
    this.event.emit(this.result);
    this.bsModalRef.hide();
    // this.dialogService.removeAll();
    document.getElementsByTagName('body')[0].style.overflowY = 'scroll'
  }

  closeDialogue(selecteTab) {
    if (selecteTab === this.tabs.GDO_ACTIVITIES || selecteTab === this.tabs.ACTIVITIES || selecteTab === this.tabs.USER_TYPE || selecteTab === this.tabs.RANGE_PICKER || selecteTab === this.tabs.LOCKS) {
      this.preSelectedValue(true, selecteTab);
    }
    let setFilter = false;
    if (this.selectedLocks.length || this.selectedSources.length || this.selectedActivities.length || this.selectedGdoActivities.length) {
      setFilter = true;
    }
    const [fromDate, toDate] = this.selectedMoments;
    this.result = { setFilter, selectedLocks: this.selectedLocks, selectedSource: this.selectedSources, selectedActivities: this.selectedActivities, selectedGdoActivities: this.selectedGdoActivities, fromDate, toDate }
    this.eventClose.emit(this.result);
    this.bsModalRef.hide();
    document.getElementsByTagName('body')[0].style.overflowY = 'scroll'
  }

  checkFilterApplied(type) {
    if (type === this.filterTypes.LOCK && this.selectedLocks.length) {
      return true;
    } else if (type === this.filterTypes.USER_TYPE && this.selectedSources.length) {
      return true;
    } else if (type === this.filterTypes.ACTIVITY && this.selectedActivities.length) {
      return true;
    } else if (type === this.filterTypes.DATE_RANGE) {
      const [fromDate, toDate] = this.selectedMoments;
      if (fromDate && toDate) {
        return true;
      }
    }
    this.errorDisplay = "error-msg-display";
    return false;
  }

  closeModal() {
    document.getElementsByTagName('body')[0].style.overflowY = 'scroll'
    // this.close();
  }

  isActivityChecked(activity) {
    return this.selectedActivities.find(ele => ele[this.defaultLangCode] === activity[this.defaultLangCode]);
  }
  isGdoActivityChecked(activity) {
    return this.selectedGdoActivities.find(ele => ele[this.defaultLangCode] === activity[this.defaultLangCode]);
  }
}
